// gavion.email.editor.* — TipTap toolbar (B5-T8 EditorToolbar keys).
export const editorMessages = {
  fr: {
    toolbar: "Mise en forme",
    bold: "Gras",
    italic: "Italique",
    link: "Lien",
    link_url: "Adresse du lien (https://)",
    link_error: "Lien https:// ou mailto: seulement",
    apply: "Appliquer",
    bullet_list: "Liste à puces",
    ordered_list: "Liste numérotée",
    variables: "Variables",
    image: "Image",
    image_logo: "Logo Gavion",
    image_upload: "Téléverser une image",
    image_upload_unavailable:
      "Téléversement indisponible en mode démo : utilisez le logo Gavion.",
    image_upload_hint:
      "PNG, JPEG ou GIF, 1 Mo maximum. L'image devient publique pour s'afficher chez vos destinataires.",
    image_file: "Fichier image",
    image_alt: "Texte alternatif",
    image_alt_placeholder: "Ex. : Logo Gavion",
    image_size: "Taille de l'image",
    image_size_small: "Petite (100 px)",
    image_size_medium: "Moyenne (160 px)",
    image_size_large: "Grande (240 px)",
    image_remove: "Retirer l'image",
    image_insert: "Insérer",
    image_uploading: "Téléversement…",
    image_error_type: "Format non pris en charge : PNG, JPEG ou GIF seulement.",
    image_error_size: "Image trop lourde : 1 Mo maximum.",
    image_error_upload: "Le téléversement a échoué. Réessayez.",
    cancel: "Annuler",
  },
  en: {
    toolbar: "Formatting",
    bold: "Bold",
    italic: "Italic",
    link: "Link",
    link_url: "Link address (https://)",
    link_error: "https:// or mailto: links only",
    apply: "Apply",
    bullet_list: "Bulleted list",
    ordered_list: "Numbered list",
    variables: "Variables",
    image: "Image",
    image_logo: "Gavion logo",
    image_upload: "Upload an image",
    image_upload_unavailable:
      "Upload is unavailable in demo mode: use the Gavion logo.",
    image_upload_hint:
      "PNG, JPEG or GIF, 1 MB max. The image becomes public so your recipients can see it.",
    image_file: "Image file",
    image_alt: "Alternative text",
    image_alt_placeholder: "E.g. Gavion logo",
    image_size: "Image size",
    image_size_small: "Small (100 px)",
    image_size_medium: "Medium (160 px)",
    image_size_large: "Large (240 px)",
    image_remove: "Remove image",
    image_insert: "Insert",
    image_uploading: "Uploading…",
    image_error_type: "Unsupported format: PNG, JPEG or GIF only.",
    image_error_size: "Image too large: 1 MB max.",
    image_error_upload: "Upload failed. Try again.",
    cancel: "Cancel",
  },
} as const;
